import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.search";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import listMixin from '@/components/niotaClassic/listMixin';
import listOptionsPersistenceMixin from '@/components/custom/listOptionsPersistenceMixin';
import overviewEditMixin from '@/components/core/dtwin/overviewEditMixin';
import multiSearchMixin from '@/mixins/multiSearchDigitalTwins';
import { localizeDate } from '@/utils/vuex';
import ApiService from '@/services/apiService';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewDigitalTwinDigitalTwinRulesMonitor',
  mixins: [listMixin, listOptionsPersistenceMixin, overviewEditMixin, multiSearchMixin],
  data: function data() {
    return {
      list: [],
      isFetching: false,
      serverItemsLength: -1,
      listPersistencePath: 'DigitalTwin.rulesMonitor',
      searchMode: 'multi',
      favouriteMode: 'on',
      favouriteFilter: false,
      includeVDRules: false,
      lastSearch: '',
      tableOptions: defaultTableOptions,
      defaultTableOptions: _objectSpread({}, defaultTableOptions),
      disableFetchOnCreatedMixin: true,
      historyDialog: false,
      historyQueryStartDate: new Date(new Date() - 86400000 * 5),
      historyQueryEndDate: new Date(),
      executionHistoryRule: {},
      executionHistoryTableOptions: {},
      executionHistory: [],
      executionHistoryItemsLength: -1,
      executionHistoryTableHeaders: [{
        text: this.$i18n_t('Common.date'),
        value: 'date',
        sortable: false
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionConditionResult'),
        value: 'conditionsResult',
        sortable: false
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionConditionChanged'),
        value: 'changed',
        sortable: false
      }, {
        text: this.$i18n_t('BackgroundJobs.BackgroundJobs.errorMessage'),
        value: 'execErrors',
        sortable: false
      }, {
        text: '',
        value: 'data-table-expand'
      }],
      executionHistoryTableFooter: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [15, 30, 50, 100]
      }
    };
  },
  computed: {
    tableLocalized: function tableLocalized() {
      return {
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        },
        headers: [{
          sortable: false
        }, {
          sortable: true,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.states.title'),
          value: 'title'
        }, {
          sortable: false
        }, {
          sortable: true,
          text: this.$i18n_t('Common.digitalTwins.searchLabel'),
          value: 'dtwin.title'
        }, {
          sortable: false
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.lastErrornousExecution'),
          value: 'lastTrigger'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.DigitalTwin.ruleOverviewTable.lastErrormessage'),
          value: 'properties.actions'
        }]
      };
    }
  },
  watch: {
    executionHistoryTableOptions: {
      handler: function handler() {
        if (this.executionHistoryRule) {
          this.fetchRuleExecutionHistory(this.executionHistoryRule);
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.getMultiFilterData();
  },
  methods: {
    get: get,
    localizeDate: localizeDate,
    breadCrumbsPath: function breadCrumbsPath() {
      return [{
        to: '/digitaltwin-mgmt',
        text: this.$i18n_t('Common.drawer.dTwins')
      }, this.$i18n_t('Common.drawer.dTwinRulesMonitor')];
    },
    fetchList: function fetchList() {
      var _this = this;

      var fromStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var searchItems = this.searchItems.map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });

      if (!isEqual(this.lastSearch, JSON.stringify(searchItems))) {
        this.lastSearch = JSON.stringify(searchItems);
        this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
          page: 1
        });
      }

      var tableOptions = fromStart ? _objectSpread(_objectSpread({}, this.tableOptions), {}, {
        page: 1
      }) : this.tableOptions;
      var sortBy = tableOptions.sortBy,
          sortDesc = tableOptions.sortDesc,
          page = tableOptions.page,
          itemsPerPage = tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'id';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : false;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = page ? page - 1 : 0;
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      var filters = [];
      var accountIds = this.selectedAccounts.map(function (a) {
        return a.id;
      });

      if (accountIds.length) {
        filters.push({
          type: 'tenantIds',
          ids: accountIds
        });
      } // persist options for next call of this page (during this browser-tab-session)


      this.$store.state.app.pageFilters = _objectSpread(_objectSpread({}, this.$store.state.app.pageFilters), {}, {
        DigitalTwin: _objectSpread(_objectSpread({}, get(this.$store.state.app, 'pageFilters.DigitalTwin') || {}), {}, {
          rulesMonitor: {
            searchDetails: this.searchItems,
            tableOptions: tableOptions,
            favouriteFilter: this.favouriteFilter || false
          }
        })
      });
      ApiService.digitalTwinFetchRulesWithErrornousExecutions(this, usedPage * usedItemsPerPage, usedItemsPerPage, {
        variable: sortItem,
        direction: sortDirection
      }, searchItems, // NOTE: not yet implemented on BE-side
      filters, this.favouriteFilter ? ['favourites'] : null, this.includeVDRules).then(function (res) {
        _this.list = res.errorRules;
        _this.serverItemsLength = res.totalCount;
      }).catch(function (error) {
        console.error('Error fetching twin-list', error);
      }).finally(function () {
        _this.isFetching = false;
      });
    },
    updatePagination: function updatePagination(e) {
      this.$router.replace({
        query: _objectSpread(_objectSpread(_objectSpread({}, this.$route.query), {
          page: e.page || defaultTableOptions.page
        }), {
          perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    processedRuleActions: function processedRuleActions(rule) {
      var _this2 = this;

      return (get(rule, 'properties.actions') || []).map(function (action) {
        return _this2.processRuleAction(action);
      });
    },
    processRuleAction: function processRuleAction(action) {
      var commandParts = (get(action, 'command') || '').split('.');

      if (commandParts.length < 2) {
        return {};
      }

      var bridgeInstanceId = commandParts[0];
      var command = action.command.substring(bridgeInstanceId.length + 1);
      var triggerType = action.triggerType === 'CHANGES' ? this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.changes') : this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.evaluates');
      var bridgeInstance = this.bridgeInstances.find(function (b) {
        return b.id === parseInt(bridgeInstanceId);
      });
      return {
        command: "".concat(get(bridgeInstance, 'name') || 'Unknown', ".").concat(command),
        condition: "".concat(this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ifCondition'), " ").concat(triggerType, " ").concat(this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionTo'), " ").concat(action.triggerValue),
        lastExecution: action.lastExecution ? this.localizeDate(get(action, 'lastExecution.date') || null) : null
      };
    },
    baseDetailLink: function baseDetailLink(item) {
      var basePath = item.dtwin.type === 'virtualDevice' ? 'virtual-devices' : 'digitaltwin-mgmt';
      return "/".concat(basePath, "/").concat(item.dtwinId);
    },
    detailButtonClicked: function detailButtonClicked(item) {
      this.$router.push("".concat(this.baseDetailLink(item), "?ruleId=").concat(item.id), '_blank');
    },
    openExecutionHistoryDialog: function openExecutionHistoryDialog(rule) {
      // for initial opening, set the execution-timeframe to within the latest errornous execution-date
      this.historyDialog = false;
      this.historyQueryEndDate = new Date(rule.errorExec.date);
      this.historyQueryStartDate = new Date(new Date(rule.errorExec.date) - 86400 * 1000 * 14);
      this.fetchRuleExecutionHistory(rule, true);
    },
    fetchRuleExecutionHistory: function fetchRuleExecutionHistory(rule) {
      var _this3 = this;

      var resetTableOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.historyDialog = true;

      if (resetTableOptions) {
        this.executionHistoryRule = rule; // reset to page 1,

        this.executionHistoryTableOptions = _objectSpread(_objectSpread({}, this.executionHistoryTableOptions), {}, {
          page: 1,
          itemsPerPage: 15
        }); // above will trigger a call to fetchRuleExecutionHistory

        return;
      }

      var _this$executionHistor = this.executionHistoryTableOptions,
          page = _this$executionHistor.page,
          itemsPerPage = _this$executionHistor.itemsPerPage;
      var usedPage = Math.max(1, page || 1);
      var usedItemsPerPage = itemsPerPage || 15;
      var offset = (usedPage - 1) * usedItemsPerPage;
      this.executionHistoryRule = rule;
      ApiService.digitalTwinFetchRuleExecutionHistory(this, rule.dtwinId, rule.id, this.historyQueryStartDate, this.historyQueryEndDate, ['errornousonly'], offset, usedItemsPerPage).then(function (history) {
        _this3.executionHistoryItemsLength = get(history, 'totalCount') || 0;
        _this3.executionHistory = get(history, 'executions') || [];
        _this3.historyDialog = true;
      }).catch(function (error) {
        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(get(error, 'response.data.message', _this3.$i18n_t('Common.usersFetchFail')), 'error');
        }
      });
    },
    showExecutionHistoryExportDialog: function showExecutionHistoryExportDialog(rule) {
      this.executionHistoryRule = rule;
      this.executionHistoryExportDialog = true;
    },
    handleDatePicked: function handleDatePicked(dateObject) {
      this.historyQueryStartDate = new Date(dateObject.from * 1000);
      this.historyQueryEndDate = new Date(dateObject.to * 1000);
      this.fetchRuleExecutionHistory(this.executionHistoryRule, true);
    }
  }
};